<template>
	<div class="page page-product">
		<transition name="slideRight">
			<div class="footnote" v-show="canAnimate3">*Плейстейшн Про</div>
		</transition>
		<div class="video-wrapper">
			<!--<video class="video"></video>-->
			<!--<div class="video-preview" style="background-image: url('/static/img/product/ronaldo.jpg');"></div>-->
		</div>
		<div class="page-overlay"></div>
		<transition name="slideDown">
			<div class="lines-wrapper oh" v-show="canAnimate3">
				<div class="lines"></div>
			</div>
		</transition>


		<div class="page-content">
			<div class="page-container">
				<transition name="slideLeft">
					<h1 class="title" v-show="canAnimate3">УЖЕ В&nbsp;ПРОДАЖЕ</h1>
				</transition>
				<transition name="slideRight">
					<p class="text" v-show="canAnimate3">
						FIFA 18&nbsp;на базе Frostbite&trade; стирает границы между виртуальным и&nbsp;реальным миром, досконально воссоздавая игроков, команды и&nbsp;атмосферу настоящего футбола.
					</p>
				</transition>
				<transition name="slideUp">
					<div class="product" v-show="canAnimate3"></div>
				</transition>
				<transition name="slideDown">
					<a
							@click="Helpers.ga().send('click','Купить Fifa');"
							v-show="canAnimate3"
							href="https://www.easports.com/ru/fifa/buy/russia?utm_campaign=fifa18_hd_ru_scm_fixd_dcm&utm_medium=display&utm_source=championat_buy_sp&utm_content=banner&utm_term=c3"
							target="_blank"
							class="btn">
						КУПИТЬ
					</a>
				</transition>
			</div>

		</div>
	</div>
</template>

<script>
	import {TweenMax} from 'gsap'
	import Helpers from '@/tools/Helpers'

	export default {
		name: 'Product',
		props: ['canAnimate3'],
		data() {
			return {
				Helpers
			}
		},
		components: {
			Helpers
		},
		computed: {
			showPage() {
				return this.$route.name === 'Product'
			}
		},
	}
</script>
<style lang="scss" scoped>
	.fadeIn-enter-active,
	.fadeIn-leave-active {
		opacity: 1;
		transition: opacity 1.5s;
	}

	.fadeIn-enter {
		opacity: 0;
	}

	.fadeIn-leave-to {
		opacity: 0;
	}

	.slideLeft-enter-active,
	.slideLeft-leave-active {
		opacity: 1;
		transition: opacity 1.5s, transform 1.5s;
		transform: translate3d(0, 0, 0);
	}

	.slideLeft-enter {
		opacity: 0;
		transform: translate3d(-100%, 0, 0);
	}

	.slideLeft-leave-to {
		opacity: 0;
		transform: translate3d(-100%, 0, 0);
	}

	.slideRight-enter-active,
	.slideRight-leave-active {
		opacity: 1;
		transition: opacity 1.5s, transform 1.5s;
		transform: translate3d(0, 0, 0);
	}

	.slideRight-enter {
		opacity: 0;
		transform: translate3d(100%, 0, 0);
	}

	.slideRight-leave-to {
		opacity: 0;
		transform: translate3d(100%, 0, 0);
	}

	.slideDown-enter-active,
	.slideDown-leave-active {
		opacity: 1;
		transition: opacity 1.5s, transform 1.5s;
		transform: translate3d(0, 0, 0);
	}

	.slideDown-enter {
		opacity: 0;
		transform: translate3d(0, 100%, 0);
	}

	.slideDown-leave-to {
		opacity: 0;
		transform: translate3d(0, 100%, 0);
	}

	.slideUp-enter-active,
	.slideUp-leave-active {
		opacity: 1;
		transition: opacity 1.5s, transform 2s;
		transform: translate3d(0, 0, 0);
	}

	.slideUp-enter {
		opacity: 0;
		transform: translate3d(0, -100%, 0);
	}

	.slideUp-leave-to {
		opacity: 0;
		transform: translate3d(0, -100%, 0);
	}
</style>


// WEBPACK FOOTER //
// Product.vue?5d70eb84